export default {
  dashboards: [],
  activeDashboardIndex: 0,
  isStaging: false,
  dashboardFilters: {},
  integrationToken: null,
};
